module.exports = __webpack_public_path__ + "img/bm.64757790.png";